<div class="snickers-page-container">
  <div class="container">
<div class="no-data">
  <p>
    {{language?.No_Data.No_Participants}}
  </p>
</div>
  </div>
</div>
